import React, { Component } from "react";
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
// import moment from "moment-timezone";
// import NumberFormat from "react-number-format";

// Components
import ErrorWrap from "../../../utils/error-success/ErrorWrap";

// CKeditor
import CKEditor from "react-ckeditor-component";
import { editorReady } from "../../../../utils/editor";
import CKEditorInput from "../../../../utils/forms/CKEditorInput";

// CSS
import "../../../../css/forms/datepicker.css";

class CCAFieldset extends Component {
	constructor(props) {
		super(props);
		this.CKEditorInput = new CKEditorInput();

		this.dataProps = [
			"profile_type",
			"cca_notes",
			"cca_training",
			"number_of_reviews",
			"has_been_team_lead",
			"dropped_out_of_review"
		];
		this.miscProps = ["errors", "profileTypesError", "profileTypesLoading", "profileTypes"];
	}

	shouldComponentUpdate(nextProps) {
		// If the parent component is processing, we should re-render to show disabled states, etc
		if (this.props.inProcess !== nextProps.inProcess) {
			this.CKEditorInput.setCKReadonly(nextProps.inProcess);
			return true;
		}

		// Check local props to see if any have changed
		const dataPropResults = this.dataProps.some(prop => {
			return this.props.data[prop] !== nextProps.data[prop];
		});
		const miscPropResults = this.miscProps.some(prop => {
			return this.props[prop] !== nextProps[prop];
		});

		// If any local props changed, we will rerender
		return dataPropResults || miscPropResults;
	}

	render() {
		const { data, errors, inProcess } = this.props;

		return (
			<div className="fieldset">
				<div className="title-label">CCA Information</div>

				<div className="fieldset-indent">
					<div className="form-field">
						<label>CCA Notes:</label>

						{!!errors.cca_notes && <ErrorWrap animate={1}>{errors.cca_notes}</ErrorWrap>}
						<CKEditor
							scriptUrl="/ckeditor/ckeditor.js"
							content={data.cca_notes}
							config={{
								toolbar: "BasicWithTools",
								filebrowserBrowseUrl: "/file-browser",
								uploadUrl: process.env.REACT_APP_API_URL + `files`
							}}
							events={{
								instanceReady: editorReady.bind(this),
								change: this.props.editorChange.bind(this, "cca_notes")
							}}
							ref={instance => {
								this.CKEditorInput.addEditor("cca_notes", instance);
							}}
						/>
					</div>

					<div className="form-field">
						<label>Training Date:</label>

						{!!errors.cca_training && (
							<ErrorWrap animate={1}>{errors.cca_training}</ErrorWrap>
						)}
						<DatePicker
							className="date"
							selected={data.cca_training}
							disabled={inProcess}
							onChange={e => this.props.updateSelectedValue(e, "cca_training")}
							showTimeSelect
							dateFormat="LLL"
							placeholderText="Click to select a date"
						/>
					</div>

					<div className="form-field">
						<div className="form-field single-line-checkbox">
							{!!errors.has_been_team_lead && (
								<ErrorWrap animate={1}>{errors.has_been_team_lead}</ErrorWrap>
							)}
							<div
								className={`custom-label checkbox-label${
									inProcess ? " disabled-label" : ""
								}`}
							>
								<input
									type="checkbox"
									id="has_been_team_lead"
									value="1"
									checked={data.has_been_team_lead}
									disabled={inProcess}
									onChange={e => this.props.handleCheckboxClick(e, 'has_been_team_lead')}
								/>
								<label htmlFor="has_been_team_lead">Has been team lead</label>
							</div>
						</div>

						<div className="form-field single-line-checkbox">
							{!!errors.dropped_out_of_review && (
								<ErrorWrap animate={1}>{errors.dropped_out_of_review}</ErrorWrap>
							)}
							<div
								className={`custom-label checkbox-label${
									inProcess ? " disabled-label" : ""
								}`}
							>
								<input
									type="checkbox"
									id="dropped_out_of_review"
									value="1"
									checked={data.dropped_out_of_review}
									disabled={inProcess}
									onChange={e => this.props.handleCheckboxClick(e, 'dropped_out_of_review')}
								/>
								<label htmlFor="dropped_out_of_review">Dropped out of review</label>
							</div>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default CCAFieldset;



// WEBPACK FOOTER //
// ./src/components/admin/reviewers/form-components/CCAFieldset.js